// extracted by mini-css-extract-plugin
module.exports = {"grid":"style_grid__AYwIG","column":"style_column__2SlK2","row":"style_row__MQw-V","wrapperAccordion":"style_wrapperAccordion__3pnBb","columnOpen":"style_columnOpen__cpAIV"};